export const organizationTags = [
  {
    id: 124,
    name: 'Tag 1',
    createdAt: '2021-08-26T14:34:43.747Z',
    updatedAt: '2021-08-26T15:02:36.685Z',
    createdBy: 138,
    updatedBy: 138,
    organizationId: 8,
  },
];
